import type { SelectLabelProps as RadixSelectLabelProps } from "@radix-ui/react-select";
import { Label } from "@radix-ui/react-select";
import type { Ref } from "react";

import { cn } from "../../../utils";

export interface SelectLabelProps extends Omit<RadixSelectLabelProps, "value"> {
  ref?: Ref<HTMLDivElement>;
  className?: string;
}

export const SelectLabel = ({ ref, className, ...props }: SelectLabelProps) => {
  return (
    <Label
      ref={ref}
      className={cn("ui:px-2 ui:py-1.5 ui:text-sm ui:font-semibold", className)}
      {...props}
    />
  );
};
